export const TIMER_OTP_COUNT = 60;
export const WA_NUMBER = "+6281393266093"
// export const WA_NUMBER = "+6281228132092"
